import React from "react";
import './card.css';

export default function Card(props) {
    return (
        <section className="project-card">
            <div className="project-card-container">
            <div className="image--header">
                <img src={props.img} className="project-image"/>
            </div>
            <div className="info">
                <span className="project-name">{props.name}</span>
                <span className="project-desc">{props.desc}</span>
                <div className="project-tech">
    {props.link1 && props.tech1 && (
        <a href={props.link1}>
            <img src={props.tech1} className="tech--img1" alt="Tech 1" />
        </a>
    )}
    {props.link2 && props.tech2 && (
        <a href={props.link2}>
            <img src={props.tech2} className="tech--img2" alt="Tech 2" />
        </a>
    )}
    {props.link3 && props.tech3 && (
        <a href={props.link3}>
            <img src={props.tech3} className="tech--img2" alt="Tech 2" />
        </a>
    )}
</div>
            </div>
            </div>
        </section>
    );
}